import React from 'react';
import { useTranslation } from 'react-i18next';
import { CookieBanner, cookieBannerLabels } from '@easydent/shared-ui';

/**
 * The shared cookie banner, in the language the rest of the site is using.
 *
 * This app keeps its resources inline under the default `translation` namespace rather than in
 * per-namespace JSON files, so the keys sit at `common.cookieBanner.*` and the prefix is passed
 * explicitly. Resources are bundled, so nothing can suspend here, but the flag is kept for
 * consistency with the other two copies.
 */
const AppCookieBanner: React.FC = () => {
  const { t } = useTranslation(undefined, { useSuspense: false });
  return <CookieBanner labels={cookieBannerLabels(t, 'common.cookieBanner')} />;
};

export default AppCookieBanner;
